import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormat } from "hooks/useFormat";
import Typography from "components/basic/typography";
import { ReviseQuoteDraft } from "../../types";
import { draftTotals } from "../../helpers";

export interface TotalsPreviewProps {
  draft: ReviseQuoteDraft;
  taxRate: number;
  taxLabel: string;
}

/**
 * What the customer will see. Priced the same way the server prices it, so the
 * vendor is never shown a total that the save then changes.
 */
const TotalsPreview: React.FC<TotalsPreviewProps> = ({
  draft,
  taxRate,
  taxLabel,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("leads");
  const totals = draftTotals(draft, taxRate);
  const { money } = useFormat();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
        padding: theme.spacing(1.5),
        borderRadius: 8,
        backgroundColor: theme.palette.action.hover,
      }}
    >
      <Typography variant="body2">
        {t("revise.subtotal", { amount: money(totals.subtotal) })}
      </Typography>
      <Typography variant="body2">
        {t("revise.tax", {
          label: taxLabel,
          amount: money(totals.taxAmount),
        })}
      </Typography>
      <Typography variant="subtitle2">
        {t("revise.total", { amount: money(totals.total) })}
      </Typography>
    </div>
  );
};

export default TotalsPreview;
